export default "__VITE_ASSET__58fd6885__"